import request from '@/utils/request'

export function getDealerList(selrId,srchDiv) {
    if(!selrId) return
    let params = {
        selrId: selrId,
        srchDiv: srchDiv,
        nextOperationId:'1100000127'
    }
    return request({
        url: `/ococ/datacapture/tps/dealerList`,
        method: 'get',
        params
    })
}

export function getMacInfo() {
    return request({
        url: `/ococ/datacapture/v1/mac`,
        method: 'get'
    })
}

export function getIpAddress() {
    return request({
        url: `/ococ/metadata/v1/ip`,
        method: 'get'
    })
}

export function sendHomeIoTAppfToUCube(appfData) {
    return request({
        url: `/ococ/activation/v1/homeTPSAppf/sbgnFnsh`,
        method: 'put',
        data:appfData
    })
}

export function getAreaNoBtZpcd(zip) {
    let params = {
        zip: zip,
        nextOperationId:'1100000127'
    }
    return request({
        url: `/ococ/datacapture/tps/areaNoBtZpcd`,
        method: 'get',
        params
    })
}

export function getFnpPrevEnpr(zip,trno,txno,tsno) {
    let params = {
        zip: zip,
        trno: trno,
        txno: txno,
        tsno: tsno,
        nextOperationId:'1100000127'
    }
    return request({
        url: `/ococ/datacapture/tps/fnpPrevEnpr`,
        method: 'get',
        params
    })
}


export function getFpnRqstPsblYn(trno,txno,tsno) {
    let params = {
        trno: trno,
        txno: txno,
        tsno: tsno,
        nextOperationId:'1100000127'
    }
    return request({
        url: `/ococ/datacapture/tps/fnpRqstPsblYn`,
        method: 'get',
        params
    })
}

export function getHmCntcInfo(autnIfSno,bsRegNo,type) {
    let params = {
        autnIfSno: autnIfSno,
        bsRegNo: bsRegNo,
        type: type,
        nextOperationId:'1100000127'
    }
    return request({
        url: `/ococ/datacapture/tps/hmCntcInfo`,
        method: 'get',
        params
    })
}

/**
 * 대리점 코드에 해당 하는 pos정보 가져옴. 
 */ 
export function getPosList(srchKd,dlrCd) {
    if(!dlrCd) return
     let params = {
        srchKd: srchKd,        
        dlrCd: dlrCd
     }
    return request({
        url: `/ococ/datacapture/v1/openmarket/form/posinfo`,
        method: 'get',
        params
    })
}

/**
 * [CSR ID: RITM2071346] PrivacyCenter 통합관리시스템 구축 2차 온라인가입지원 프로젝트
 * HomeIoT 개인정보활용동의항목 목록 조회
 */ 
export function getHmCupsifItemList(param) {
    let params = {
        cupsifChnlSysId:param
    }
    return request({
        url: `/ococ/datacapture/tps/hmCupsifItemList`,
        method: 'get',
        params
    })
}
